import { useContent } from "./ContentContext";
import { DEFAULT_TEXT, txtStyle } from "./textConfig";

const FALLBACK = { text: "", size: "md", weight: "normal" };

// Returns a getter for an editable text field { text, size, weight }.
// Falls back to the schema defaults so the site never renders empty.
export const useTx = () => {
  const { settings } = useContent();
  const text = settings.text || {};
  return (key) => text[key] || DEFAULT_TEXT[key] || FALLBACK;
};

// Inline typography style (font-size + weight) for a given field.
export { txtStyle };

// Split a "\n"-separated string into React nodes with <br /> breaks.
export const multiline = (str = "") => {
  const lines = String(str).split("\n");
  return lines.map((ln, i) => (
    <span key={i}>
      {ln}
      {i < lines.length - 1 && <br />}
    </span>
  ));
};
